import {bookingDefault, bookingFlows} from "../constants/global";
import {BookingService} from "../types";
import {validateEmail} from "./helpers";
import {resetDateCarousel} from "./date-caroussel"

export function isServiceActive (slug: string, booking:Booking) {
    return booking.serviceArray.find(item => item.slug === slug);
}
export function isStepCarFulfilled (booking:Booking, validate:boolean) {
    if(isStepDateFulfilled(booking, false))
        return true

    if(!booking.car.reg || !booking.car.model || !booking.car.year)
        return false

    return true
}

export function isStepServiceFulfilled (booking:Booking, validate:boolean, setBooking:Function=null) {

    if(booking.serviceArray.length === 0)
        return false

    if(!bookingFlows[booking.booking_flow].menu.includes('service')) {
        return true;
    }

    for(let i = 0; i < booking.serviceArray.length; i++) {
        const service = booking.serviceArray[i]

        if(service.mandatory_mileage && booking.car.mileage === 0) {
            if(validate) {
                booking.modal = 7;
                storeBooking(booking, setBooking)
            }
            return false
        }

        if(service.slug === 'reparation' && booking.repair_desc.length < 4) {
            if(validate) {
                booking.modal = 8;
                storeBooking(booking, setBooking)
            }
            return false
        }
    }

    return true
}

export function isStepDateFulfilled (booking:Booking, validate:boolean=false, setBooking:Function=null) {
    if(!isStepServiceFulfilled(booking, false, null))
        return false

    if(booking.booking_flow === 'hjulskifte' || booking.booking_flow === 'hjulskifte-arval') {
        if(!booking.hjulskifte.spot_id) {
            return false
        }
    }

    if(booking.booking_flow === 'window' && booking.window.form.window_damage_type === 'chip' && booking.service.booking_flow === 'window') {
        if(!booking.window.spot_id)
            return false
    }


    if(!booking.date || booking.date==='') {
        if(validate) {
            booking.modal = 9;
            storeBooking(booking, setBooking)
        }
        return false
    }

    if(booking.loan_car === 'idle' && booking.dateHasLoanCar) {
        if(validate) {
            booking.modal = 11;
            storeBooking(booking, setBooking)
        }
        return false
    }

    if(!booking.submission.slug) {
        if(validate) {
            booking.modal = 10;
            storeBooking(booking, setBooking)
        }
        return false
    }

    return true
}

export function isStepContactFulfilled (booking:Booking, validate:boolean=false, setBooking:Function=null) {
    if(!isStepServiceFulfilled(booking, false, null))
        return false

    if(!booking.hjulskifte.spot_id && booking.booking_flow === 'hjulskifte')
        return false

    if(!booking.contact.lastname || !booking.contact.phone || !booking.contact.mail) {
        if(validate) {
            booking.modal = 12;
            storeBooking(booking, setBooking)
        }
        return false
    }

    if(!validateEmail(booking.contact.mail)){
        if(validate) {
            booking.modal = 12;
            storeBooking(booking, setBooking)
        }
        return false
    }

    return validateEmail(booking.contact.mail)
}

export function isStepWindowFulfilled (booking:Booking, validate:boolean) {
    if(!isStepServiceFulfilled(booking, false))
        return false

    /*if(!booking.window.form.damage_date)
        return false

    if(!booking.window.form.insurance_company)
        return false

    if(!booking.window.form.damage_place)
        return false*/

    if(!booking.window.form.window_damage_type) {
        return false
    }

    if(booking.window.form.window_damage_type === 'chip') {
        /*if( booking.window.form.chip_marker_data.red > 0 )
            return false*/

        if( booking.window.form.chip_counter === 0 )
            return false

        if( booking.window.form.chip_counter > 3 )
            return false
    }

    return true
}

export function isStepOptionsFulfilled (booking:Booking, validate:boolean=false, setBooking:Function=null) {

    if(!isStepServiceFulfilled(booking, false) || !isStepDateFulfilled(booking, false))
        return false

    if(booking.hjulskifte.spot_id && booking.tires.store === "") {
        return false
    }

    if(booking.options_extra.service_agreement === 'required' && setBooking){
        booking.modal = 14;
        storeBooking(booking, setBooking)
        return false
    }

    if(booking.submission.type.includes("address")) {
        if(!booking.submission.address)
            return false

        if(!booking.submission.postal)
            return false

        if(!booking.submission.city)
            return false
    }

    if(booking.submission.type.includes("time")) {
        if(!booking.submission.time) {
            //return false
        }
    }

    /*if(booking.car.brand === 'Volvo') {
        if(!booking.options_extra.volvo_pst)
            return false
    }*/

    return true
}

export function getPrioritizedService(serviceArray:any) {
    let so = 1000;
    let service:BookingService = bookingDefault.service
    for(let i=0; i<serviceArray.length; i++){
        var s = parseInt(serviceArray[i].order);
        if(s<so) {
            so = s;
            service = serviceArray[i]
        }
    }
    //service.image = ''
    //service.info = ''
    return service
}

export function isStepFulfilled(step:any, booking:Booking, setBooking:Function=null, validate:boolean=false) {
    //return true;

    switch(step) {
        case 'car':
            //return true;
            return isStepCarFulfilled(booking, validate)
        case 'service':
            //return true;
            return isStepServiceFulfilled(booking, validate, setBooking)
        case 'date':
            return isStepDateFulfilled(booking, validate, setBooking)
        case 'submission':
            return true
        case 'options':
            //return true
            return isStepOptionsFulfilled(booking, validate, setBooking)
        case 'contact':
            return isStepContactFulfilled(booking, validate, setBooking)
        case 'window':
            return isStepWindowFulfilled(booking, validate)
        default:
            return true;
    }
}

export function getNextStep (steps:any, activeStep:string) {
    console.log('steps', steps)
    for (let i = 0; i<steps.length; i++) {
        if(steps[i] === activeStep && i<steps.length-1)
            return steps[i+1]
    }
    return null
}

export function getPrevStep (steps:any, activeStep:string) {
    for (let i = 0; i<steps.length; i++) {
        if(steps[i] === activeStep && i>0)
            return steps[i-1]
    }
    return null
}

export function serviceName (booking:Booking, service:any) {
    if(booking.tires.store && service.booking_flow === 'hjulskifte')
        return booking.tires.store === 'yes' ? service.name + ' + däckhotell' : service.name

    return service.name
}

export function servicePriceString (booking:Booking, service:any) {
    if(service.slug === 'glas' || service.slug === 'bilglas') {
        return 'insurance'
    }

    // NIO exception
    if(service.booking_flow === 'hjulskifte' && booking.car.brand.toLowerCase() === 'nio')
        return 'Pris offereras på mail efter bokning'

    // Arval exception
    if(service.booking_flow === 'hjulskifte' && booking.car.arval)
        return 'Pris offereras på mail efter bokning'

    if(!service.price) {
        return 'Pris offereras på mail efter bokning'
    }

    if(booking.hjulskifte.options.product_id && service.booking_flow === 'hjulskifte') {

        if(!booking.hjulskifte.options.quantity && booking.tires.store === 'yes')
            return service.meta.price_inc_hotel

        if(booking.hjulskifte.options.quantity === 2 && booking.tires.store === 'yes')
            return service.meta.price_inc_hotel_tire_2

        if(booking.hjulskifte.options.quantity === 4 && booking.tires.store === 'yes')
            return service.meta.price_inc_hotel_tire_4

        if(!booking.hjulskifte.options.quantity)
            return service.price

        if(booking.hjulskifte.options.quantity === 2)
            return Math.round(service.price/2);

        if(booking.hjulskifte.options.quantity === 4)
            return 0;
    }

    if(booking.tires.store === 'yes' && service.booking_flow === 'hjulskifte')
        return service.meta.price_inc_hotel


    return service.price
}

export function createBooking (booking:Booking) {
    console.log('create booking: ', booking)
}

export function getBookingFlowStepNum (booking:Booking) {
    const bookingFlow = bookingFlows[booking.booking_flow]
    for(let i=0; i<bookingFlows[booking.booking_flow].menu.length; i++){
        if(bookingFlows[booking.booking_flow].menu[i] === bookingFlow.step)
            return i+1
    }
}

// Update booking object and store in session storage
export function storeBooking(booking:Booking, setBooking:Function) {
    setBooking({
        ...booking,
    })
}

export function resetBooking() {
    //window.react_data.reg = 'XLU007';
    const reset:Booking = {
        debug: false,
        page:'din-bil',
        session: parseInt(sessionStorage.getItem('mech_session') || Date.now().toString()),
        car: {
            reg: window.react_data.reg ? window.react_data.reg : '',
            brand: '',
            model: '',
            year: '',
            mileage: 0,
            color: '',
            tacdis: false,
            service: '',
            valid: false,
            manual: false,
            authorized:false,
            autoload:!!window.react_data.reg,
            arval:false,
            insurance:null,
            vbo:false
        },
        booking_flow: window.react_data.booking_flow ? window.react_data.booking_flow : 'default',
        loan_car: 'idle',
        loan_car_price: 199,
        loan_car_mercedes: false,
        loan_car_opel: false,
        service: {
            id: null,
            auth: false,
            booking_flow: 'default',
            mandatory_mileage: false,
            name: '',
            order: null,
            slug: '',
            value: null,
            image:'',
            info:'',
            price:0
        },
        serviceArray: [],
        workshop: window.react_data.center ? window.react_data.center : null,
        resource:null,
        resourceId:null,
        group:null,
        date:'',
        dateHasLoanCar:false,
        isLastMinute:false,
        isLastMinuteMessage:'',
        hjulskifte: {
            assembly_price: 399,
            date: '',
            spot_id: '',
            options: {
                product_id: null,
                quantity: null,
                name:null,
                price:null
            },
            mail_customer_id: ''
        },
        tire_change: false,
        tires: {
            dimension: '',
            stored: true,
            store: '',
            send_offer: false
        },
        window: {
            in_booking_flow: false,
            form: {
                insurance_company: '',
                damage_date: '',
                damage_place: '',
                chip_counter: 0,
                order_comments: '',
                window_damage_type: '',
                window_repair_image: '',
                chip_marker_data: {
                    coords: [{}],
                    green: 0,
                    red: 0,
                    yellow: 0,
                    status: false
                }
            },
            date: '',
            spot_id: '',
            calendar: {
                year: '',
                month: ''
            }
        },
        repair_desc:'',
        options: [],
        options_extra: {
            volvo_pst: '',
            vw_connect: false,
            mercedes_code: '',
            service_agreement: 'disabled'
        },
        contact: {
            firstname: null,
            lastname: null,
            phone: null,
            mail: null,
            coupon: null,
            message: null,
            marketing: false,
            newsletter: false,
            workshop: null
        },
        submission: {
            slug: '',
            name: '',
            type: [],
            time: '',
            address: '',
            postal: '',
            city: '',
            reload: false
        },
        modal:0,
        modal_message:'',
        loading: !!window.react_data.reg,
        classNames:null,
        populated_services: typeof window.react_data.populated_services === 'string'
            ? window.react_data.populated_services.split(',').map((s: string) => s.trim()).filter(Boolean)
            : (window.react_data.populated_services ?? []),
        order_key: window.react_data.order_key ? window.react_data.order_key : '',
        order_loading: false,
        hjulskifte_key: window.react_data.hjulskifte_key ? window.react_data.hjulskifte_key : '',
        tire_shop:[],
        calendar_carousel: resetDateCarousel(),
        code: window.react_data.code ? window.react_data.code : '',
        csrf_token: window.react_data.csrf_token ? window.react_data.csrf_token : '',
    }
    return reset
}
